<template>
  <div @click="submit" ref="buttonChild_ref">
    <div
      class="waitTips"
      v-if="
        buttonData.countNum > 0 && payLoading && buttonData.loading === false
      "
    >
      {{ $t("components_confirmPay_btn.waitingTips") }}
      {{ countDown ? countDown : "" }}
    </div>
    <button
      class="button"
      :disabled="disabled"
      :class="{ loadingDisabled: buttonData.loading }"
      v-else
    >
      <slot v-if="buttonData.customName" />
      <div style="display: flex; align-items: center" v-else>
        <p>
          {{ $t(buttonName) + "" }}
          <span>{{ countDown ? countDown : "" }}</span>
        </p>
      </div>
      <i v-if="buttonData.loading" class="el-icon-loading loadingIcon"></i>
      <span class="iconView" v-if="this.buttonData.countNum < 1">
        <i v-if="buttonData.loading" class="el-icon-loading loadingIcon"></i>
        <img
          v-else
          class="rightIcon"
          src="@/assets/images/direction-icon/button-right-icon.svg"
          alt=""
        />
      </span>
    </button>
  </div>
</template>

<script>
/**
 * 我方收银台确认支付按钮（包括线下转账）
 * @param disabled {Boolean} 按钮禁选状态
 * @param buttonData {Object} loading 按钮主动触发loading状态 confirmSuccess 确认成功状态 countNum 点击数量
 * @param countDown {String} 倒计时时间
 */
import { mapState } from "vuex";

export default {
  name: "confirm-pay-my",
  props: {
    disabled: {
      type: Boolean,
      default: null,
    },
    buttonData: {
      type: Object,
      default: null,
    },
    countDown: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      //按钮文案
      buttonName: "nav.ConfirmPayment",
      newButtonData: {},
    };
  },
  computed: {
    ...mapState("buyNftOrder", {
      payMethodInfo: (state) => state.payMethodInfo,
    }),
    payLoading() {
      if (
        [
          "201",
          "202",
          "203",
          "205",
          "206",
          "207",
          "208",
          "209",
          "10009",
          "10005",
          "10006",
        ].includes(this.payMethodInfo.payWayCode)
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    buttonData: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.confirmSuccess === true) {
          // this.buttonName = "Waiting for your payment";
          this.buttonData.loading = false;
        }
      },
    },
  },
  methods: {
    submit() {
      this.buttonData.countNum += 1;

      if (this.buttonData.countNum === 1 && !this.buttonData.confirmSuccess) {
        this.buttonData.loading = true;
      }

      //确认过再次点击 - 弹框确认
      // if(this.buttonData.confirmSuccess === true  && this.buttonData.loading === false){
      //   this.$parent.$parent.BuyTimeOut = '';
      //   this.$parent.$parent.tipsState = true;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.waitTips {
  font-family: Medium;
  font-weight: 500;
  font-size: 0.24rem;
  line-height: 0.29rem;
  color: #0059da;
  text-align: center;
}

.button {
  width: 100%;
  height: 0.58rem;
  background: linear-gradient(88.06deg, #0059da 0%, #1bb2f2 100%);
  border-radius: 0.29rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.17rem;
  font-family: Regular;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  border: none;
  .iconView {
    display: flex;
    align-items: center;
  }
  .rightIcon {
    width: 0.24rem;
    margin-left: 0.08rem;
  }
  .loadingIcon {
    font-size: 0.24rem;
    margin-left: 0.08rem;
  }
}
.button[disabled] {
  opacity: 0.25;
  cursor: no-drop;
}
.loadingDisabled {
  opacity: 0.25 !important;
  cursor: no-drop !important;
}
</style>
